export class DeleteUserApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Delete team member by id
     * @returns User
     * @throws ApiError
     */
    deleteTeamMemberById({ id, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/delete-user/team-member/{id}',
            path: {
                'id': id,
            },
        });
    }
}
